import axios from "axios";
import { del, get, post, patch,  put } from "./semesters_api_helper";
import * as url from "./semesters_url_helper";





// Get features
export const getSemesters = () => get(url.GET_SEMESTERS);


// Add feature
export const addNewSemester = (semester) => post(url.ADD_NEW_SEMESTER, semester);
//export const addNewBranch = branch => post(url.ADD_NEW_BRANCH, JSON.stringify(branch));




// update feature
//export const updateFeature = feature => put(url.UPDATE_ACTION, feature);
export const updateSemester = (semester) => patch(`${url.UPDATE_SEMESTER}/${semester.id}`,  semester);


// delete series categories
//export const deleteFeature = feature => del(url.DELETE_ACTION, { headers: { feature } });
export const deleteSemester = (semester) => del(`${url.DELETE_SEMESTER}/${semester.id}`);







export {
  //getLoggedInUser,
  
  
};
